import * as React from 'react';

const Box = ({ children }) => <div className="box">{children}</div>;

export default Box;
